'use client'

import Link from 'next/link'
import { useEffect } from 'react'

export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {}, [error])
  return (
    <main style={{ maxWidth: 960, margin: '0 auto', padding: '48px 20px' }}>
      <h1 style={{ margin: 0, fontSize: 28, lineHeight: 1.2 }}>Something went wrong</h1>
      <p style={{ marginTop: 10, color: 'var(--muted)', lineHeight: 1.6 }}>
        Try reloading this section. If it keeps happening, go back home.
      </p>
      <div style={{ marginTop: 16, display: 'flex', gap: 10, flexWrap: 'wrap' }}>
        <button
          onClick={() => reset()}
          style={{
            padding: '10px 14px',
            borderRadius: 12,
            border: '1px solid #0b0b0f',
            background: '#0b0b0f',
            color: '#ffffff',
            fontWeight: 900,
            cursor: 'pointer'
          }}
        >
          Try again
        </button>
        <Link
          href="/"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '10px 14px',
            borderRadius: 12,
            border: '1px solid var(--border)',
            background: 'var(--panel)',
            color: 'var(--text)',
            textDecoration: 'none',
            fontWeight: 900
          }}
        >
          Home
        </Link>
      </div>
    </main>
  )
}

